import config from '@/config'

function info (...args) {
  if (config.LOGS) {
    console.info(...args) // eslint-disable-line no-console
  }
}

function warn (...args) {
  if (config.LOGS) {
    console.warn(...args) // eslint-disable-line no-console
  }
}

function error (...args) {
  if (config.LOGS) {
    console.error(...args) // eslint-disable-line no-console
  }
}

export default {
  info,
  warn,
  error
}
